import { gql } from '@apollo/client';

export const postPrestamoPersonalSP = gql`
mutation PrestamoPersonalSPApiRQ{
    PrestamoPersonalSPApiRQ(input: $input)  
        @rest(type: "PrestamoPersonalSPApiRS", path: "/api/gateway/formularios/Semipresencial", method: "POST"){
            nroSolicitud
            nroSecuencia
            resultado
            error
            stackTrace
        }
}
`